// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/site/v1/site.proto (package fingertip.creator.site.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { ClaimSiteRequest, ClaimSiteResponse, CreateSiteRequest, CreateSiteResponse, DeleteSiteRequest, DeleteSiteResponse, DuplicateSiteRequest, DuplicateSiteResponse, GetSiteProgressRequest, GetSiteProgressResponse, GetSiteRelevanceMapRequest, GetSiteRelevanceMapResponse, GetSiteRequest, GetSiteResponse, GetSitesAdminRequest, GetSitesAdminResponse, GetSiteSlugRequest, GetSiteSlugResponse, GetSitesRequest, GetSitesResponse, MigrateHeyLinkRequest, MigrateHeyLinkResponse, MigrateSiteRequest, MigrateSiteResponse, UpdateSiteRequest, UpdateSiteResponse, VerifySitePasswordRequest, VerifySitePasswordResponse } from "./site_pb.js";

/**
 * @generated from rpc fingertip.creator.site.v1.SiteService.GetSite
 */
export const getSite = {
  localName: "getSite",
  name: "GetSite",
  kind: MethodKind.Unary,
  I: GetSiteRequest,
  O: GetSiteResponse,
  service: {
    typeName: "fingertip.creator.site.v1.SiteService"
  }
};

/**
 * @generated from rpc fingertip.creator.site.v1.SiteService.GetSiteRelevanceMap
 */
export const getSiteRelevanceMap = {
  localName: "getSiteRelevanceMap",
  name: "GetSiteRelevanceMap",
  kind: MethodKind.Unary,
  I: GetSiteRelevanceMapRequest,
  O: GetSiteRelevanceMapResponse,
  service: {
    typeName: "fingertip.creator.site.v1.SiteService"
  }
};

/**
 * @generated from rpc fingertip.creator.site.v1.SiteService.CreateSite
 */
export const createSite = {
  localName: "createSite",
  name: "CreateSite",
  kind: MethodKind.Unary,
  I: CreateSiteRequest,
  O: CreateSiteResponse,
  service: {
    typeName: "fingertip.creator.site.v1.SiteService"
  }
};

/**
 * @generated from rpc fingertip.creator.site.v1.SiteService.UpdateSite
 */
export const updateSite = {
  localName: "updateSite",
  name: "UpdateSite",
  kind: MethodKind.Unary,
  I: UpdateSiteRequest,
  O: UpdateSiteResponse,
  service: {
    typeName: "fingertip.creator.site.v1.SiteService"
  }
};

/**
 * @generated from rpc fingertip.creator.site.v1.SiteService.DeleteSite
 */
export const deleteSite = {
  localName: "deleteSite",
  name: "DeleteSite",
  kind: MethodKind.Unary,
  I: DeleteSiteRequest,
  O: DeleteSiteResponse,
  service: {
    typeName: "fingertip.creator.site.v1.SiteService"
  }
};

/**
 * @generated from rpc fingertip.creator.site.v1.SiteService.GetSites
 */
export const getSites = {
  localName: "getSites",
  name: "GetSites",
  kind: MethodKind.Unary,
  I: GetSitesRequest,
  O: GetSitesResponse,
  service: {
    typeName: "fingertip.creator.site.v1.SiteService"
  }
};

/**
 * @generated from rpc fingertip.creator.site.v1.SiteService.ClaimSite
 */
export const claimSite = {
  localName: "claimSite",
  name: "ClaimSite",
  kind: MethodKind.Unary,
  I: ClaimSiteRequest,
  O: ClaimSiteResponse,
  service: {
    typeName: "fingertip.creator.site.v1.SiteService"
  }
};

/**
 * @generated from rpc fingertip.creator.site.v1.SiteService.GetSiteSlug
 */
export const getSiteSlug = {
  localName: "getSiteSlug",
  name: "GetSiteSlug",
  kind: MethodKind.Unary,
  I: GetSiteSlugRequest,
  O: GetSiteSlugResponse,
  service: {
    typeName: "fingertip.creator.site.v1.SiteService"
  }
};

/**
 * @generated from rpc fingertip.creator.site.v1.SiteService.GetSitesAdmin
 */
export const getSitesAdmin = {
  localName: "getSitesAdmin",
  name: "GetSitesAdmin",
  kind: MethodKind.Unary,
  I: GetSitesAdminRequest,
  O: GetSitesAdminResponse,
  service: {
    typeName: "fingertip.creator.site.v1.SiteService"
  }
};

/**
 * @generated from rpc fingertip.creator.site.v1.SiteService.DuplicateSite
 */
export const duplicateSite = {
  localName: "duplicateSite",
  name: "DuplicateSite",
  kind: MethodKind.Unary,
  I: DuplicateSiteRequest,
  O: DuplicateSiteResponse,
  service: {
    typeName: "fingertip.creator.site.v1.SiteService"
  }
};

/**
 * @generated from rpc fingertip.creator.site.v1.SiteService.MigrateSite
 */
export const migrateSite = {
  localName: "migrateSite",
  name: "MigrateSite",
  kind: MethodKind.Unary,
  I: MigrateSiteRequest,
  O: MigrateSiteResponse,
  service: {
    typeName: "fingertip.creator.site.v1.SiteService"
  }
};

/**
 * @generated from rpc fingertip.creator.site.v1.SiteService.GetSiteProgress
 */
export const getSiteProgress = {
  localName: "getSiteProgress",
  name: "GetSiteProgress",
  kind: MethodKind.Unary,
  I: GetSiteProgressRequest,
  O: GetSiteProgressResponse,
  service: {
    typeName: "fingertip.creator.site.v1.SiteService"
  }
};

/**
 * @generated from rpc fingertip.creator.site.v1.SiteService.VerifySitePassword
 */
export const verifySitePassword = {
  localName: "verifySitePassword",
  name: "VerifySitePassword",
  kind: MethodKind.Unary,
  I: VerifySitePasswordRequest,
  O: VerifySitePasswordResponse,
  service: {
    typeName: "fingertip.creator.site.v1.SiteService"
  }
};

/**
 * @generated from rpc fingertip.creator.site.v1.SiteService.MigrateHeyLink
 */
export const migrateHeyLink = {
  localName: "migrateHeyLink",
  name: "MigrateHeyLink",
  kind: MethodKind.Unary,
  I: MigrateHeyLinkRequest,
  O: MigrateHeyLinkResponse,
  service: {
    typeName: "fingertip.creator.site.v1.SiteService"
  }
};
